// import "./Cookies.css";
import React, { useEffect, useState } from "react";
import "./AppSettng.css";
// import ListGroup from "react-bootstrap/ListGroup";
import Accordion from "react-bootstrap/Accordion";
import UserImage from "../common/UserImage";
// import { Button } from "react-bootstrap";
import { RiLogoutBoxFill, RiMovie2Fill, RiSearch2Fill } from "react-icons/ri";
import { FaHeadset, FaLocationDot, FaAngleRight } from "react-icons/fa6";
import { HiDocumentText } from "react-icons/hi";
import { FaShieldAlt, FaUser } from "react-icons/fa";
import { Card, Button, ListGroup, CardBody } from "react-bootstrap";
import { Link } from "react-router-dom";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";

const AppSettingPage = (props) => {
  const listGroupItem = {
    color: "#FFFFFF",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "60px",
  };
  const linkStyle = {
    textDecoration: "none", // Remove underline
    color: "inherit", // Inherit text color
  };
  const [isSubscribed, setiIsSubscribed] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [imageSrc, setImageSrc] = useState(
    "https://adminpanelconnect.bebu.app/placeholder.png"
  );
  const [user, setUser] = useState(null);
  const handleImageChange = (newImage) => {
    setImageSrc(newImage);
  };

  const logoutFunc = () => {
    try {
      localStorage.removeItem("BebuAppUser");
      // setIsUserRegistered(false);
      console.log("LOGOUT FUNCTION CALLED");
      googleLogout();
    } catch (error) {
      console.error("Error occurred during logout:", error);
    }
  };

  useEffect(() => {
    console.log("props.userData;;;", props);
    if (props.userData != null) {
      console.log("props.userData;;;", props.userData);
      setUser(props.userData);
      setImageSrc(props.userData.picture);
      setiIsSubscribed(props.userData.isSubscribed);
      setIsLoggedIn(true);
      // picture
      // fullName
      // username
    }
  }, []);

  //
  return (
    // <div>
    //   <div className="centeredImage" style={{ paddingTop: "10px" }}>
    //     <img src={imageSrc} alt="Centered Image" className="circularImage" />
    //     <label htmlFor="fileInput">
    //       <Button
    //         style={{
    //           marginTop: "10px",
    //           backgroundColor: "#58b7aa",
    //           borderWidth: "0",
    //         }}
    //       >
    //         Change
    //       </Button>
    //     </label>
    //   </div>
    //   <div
    //     className="container privacyPolicyBellowTextBox"
    //     style={{ height: "100%" }}
    //   >
    //     <div id="scroll" style={{ height: "100%" }}>
    //       <Accordion style={{ height: "100%" }}>
    //         <Accordion.Item
    //           eventKey="0"
    //           style={{
    //             backgroundColor: "transparent",
    //             borderColor: "transparent",
    //           }}
    //         >
    //           <Accordion.Header>EXPLORE</Accordion.Header>
    //           <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
    //             <ul className="custom-bullet">
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/home">
    //                   Home
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/browse">
    //                   Browse
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/subscribe">
    //                   Subscribe
    //                 </a>
    //               </li>
    //             </ul>
    //           </Accordion.Body>
    //         </Accordion.Item>
    //         <Accordion.Item
    //           eventKey="2"
    //           style={{
    //             backgroundColor: "transparent",
    //             borderColor: "transparent",
    //           }}
    //         >
    //           <Accordion.Header>QUICK LINKS</Accordion.Header>
    //           <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
    //             <ul className="custom-bullet">
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/about-us">
    //                   About Us
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/contact-us">
    //                   Contact Us
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/support">
    //                   Support
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/CookiePolicy">
    //                   Cookie Policy
    //                 </a>
    //               </li>
    //             </ul>
    //           </Accordion.Body>
    //         </Accordion.Item>
    //         <Accordion.Item
    //           eventKey="1"
    //           style={{
    //             backgroundColor: "transparent",
    //             borderColor: "transparent",
    //           }}
    //         >
    //           <Accordion.Header>LEGAL</Accordion.Header>
    //           <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
    //             <ul className="custom-bullet">
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/privacy">
    //                   Privacy Policy
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/terms-and-conditions">
    //                   Terms &amp; Conditions
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/refund-policy">
    //                   Refund Policy
    //                 </a>
    //               </li>
    //             </ul>
    //           </Accordion.Body>
    //         </Accordion.Item>
    //         <Accordion.Item
    //           eventKey="3"
    //           style={{
    //             backgroundColor: "transparent",
    //             borderColor: "transparent",
    //           }}
    //         >
    //           <Accordion.Header>PROFILE SETTINGS</Accordion.Header>
    //           <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
    //             <ul className="custom-bullet">
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/privacy">
    //                   Profile Setings
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/terms-and-conditions">
    //                   Support | Help
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/refund-policy">
    //                   Sign Out
    //                 </a>
    //               </li>
    //             </ul>
    //           </Accordion.Body>
    //         </Accordion.Item>
    //       </Accordion>
    //     </div>
    //   </div>
    // </div>
    <div
      style={{
        width: "100%",
        minHeight: "55rem",
        position: "relative",
        backgroundImage: `url(./bebuAppBG.JPEG)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#141414",
        backgroundBlendMode: "overlay",
      }}
    >
      <Card
        style={{
          backgroundColor: "transparent",
          padding: "10%",
          height: "100vh",
        }}
      >
        <Card.Header
          style={{
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <img
            src={imageSrc}
            alt="Profile Icon"
            style={{
              height: "100px",
              width: "100px",
              borderRadius: "50%",
              marginBottom: "1rem", // Adjust margin bottom as needed
            }}
          />
          <h6 className="text-white" style={{ textTransform: "capitalize" }}>
            {user && user.fullName}
          </h6>
          {user && user.login_by === "google" && (
            <h6 className="text-white">{user.email}</h6>
          )}
          {user && user.login_by === "manual" && (
            <h6 className="text-white">{user.username}</h6>
          )}
          {/* <h6 className="text-white">{user && user.email}</h6> */}
          {user == null && (
            <Button
              variant="primary"
              style={{
                backgroundColor: "#41C1AF",
                width: "100%", // Make button width 100% of the container
                border: "none",
                borderRadius: "20px",
                height: "50px",
                paddingTop: "12px",
              }}
              as={Link}
              to="/login"
            >
              Login / Register
            </Button>
          )}
          &nbsp; &nbsp;
          {isSubscribed != null && !isSubscribed && (
            <Button
              variant="primary"
              style={{
                backgroundColor: "#41C1AF",
                width: "100%", // Make button width 100% of the container
                border: "none",
                borderRadius: "20px",
                height: "50px",
                paddingTop: "12px",
              }}
              as={Link}
              to="/subscribe"
            >
              SUBSCRIBE
            </Button>
          )}
        </Card.Header>
        <div>
          <Card
            body
            style={{
              backgroundColor: "#141414",
              borderRadius: "1rem",
            }}
          >
            {" "}
            <Link to="/support" style={linkStyle}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <FaHeadset />
                <span>&nbsp; &nbsp; Support / Help</span>
                <FaAngleRight style={{ marginLeft: "auto" }} />
              </div>
            </Link>
            <hr style={{ color: "white" }} />
            <Link to="/subscribe" style={linkStyle}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <RiMovie2Fill />
                <span>&nbsp; &nbsp; Subscription</span>
                <FaAngleRight style={{ marginLeft: "auto" }} />
              </div>
            </Link>
            <hr style={{ color: "white" }} />
            <Link to="/terms-and-conditions" style={linkStyle}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <HiDocumentText />
                <span>&nbsp; &nbsp; Terms & Conditions</span>
                <FaAngleRight style={{ marginLeft: "auto" }} />
              </div>
            </Link>
            <hr style={{ color: "white" }} />
            <Link to={isLoggedIn ? "/location" : "/login"} style={linkStyle}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <FaLocationDot />
                <span>&nbsp; &nbsp; Location</span>
                <FaAngleRight style={{ marginLeft: "auto" }} />
              </div>
            </Link>
            <hr style={{ color: "white" }} />
            <Link to="/privacy" style={linkStyle}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <FaShieldAlt />
                <span>&nbsp; &nbsp; Privacy Policy</span>
                <FaAngleRight style={{ marginLeft: "auto" }} />
              </div>
            </Link>
            <hr style={{ color: "white" }} />
            <Link to="/about-us" style={linkStyle}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <FaUser />
                <span>&nbsp; &nbsp; About Us</span>
                <FaAngleRight style={{ marginLeft: "auto" }} />
              </div>
            </Link>
            {/* {user !== null ? (
              <>
                <hr style={{ color: "white" }} />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                  }}
                  onClick={logoutFunc}
                >
                  <RiLogoutBoxFill />
                  <span>&nbsp; &nbsp; Sign out</span>
                  <FaAngleRight style={{ marginLeft: "auto" }} />
                </div>
              </>
            ) : (
              <></>
            )} */}
          </Card>
        </div>

        {/* <ListGroup variant="flush" style={{ backgroundColor: "#1C1C1E" }}>
          <Link to="/support" style={linkStyle}>
            <ListGroup.Item style={listGroupItem}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FaHeadset />
                <span>&nbsp; &nbsp; Support / Help</span>
              </div>
              <FaAngleRight />
            </ListGroup.Item>
          </Link>
          <Link to="/location" style={linkStyle}>
            <ListGroup.Item style={listGroupItem}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FaLocationDot />
                <span>&nbsp; &nbsp; Location</span>
              </div>
              <FaAngleRight />
            </ListGroup.Item>
          </Link>
          <Link to="/terms-and-conditions" style={linkStyle}>
            <ListGroup.Item style={listGroupItem}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <HiDocumentText />
                <span>&nbsp; &nbsp; Terms & Conditions</span>
              </div>
              <FaAngleRight />
            </ListGroup.Item>
          </Link>

          <Link to="/privacy" style={linkStyle}>
            <ListGroup.Item style={listGroupItem}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <FaShieldAlt />
                <span>&nbsp; &nbsp; Privacy Policy</span>
              </div>
              <FaAngleRight />
            </ListGroup.Item>
          </Link>

          <Accordion style={{ height: "100%" }}>
            <Accordion.Item
              eventKey="0"
              style={{
                backgroundColor: "transparent",

                border: "none",
              }}
            >
              <Accordion.Header
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <RiSearch2Fill />
                  <span>&nbsp; &nbsp; Other</span>
                </div>
              </Accordion.Header>
              <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
                <ul className="custom-bullet">
                  <li className="nav-item">
                    <a className="nav-link" href="/subscribe">
                      Subscribe
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/about-us">
                      About Us
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/contact-us">
                      Contact Us
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/CookiePolicy">
                      Cookie Policy
                    </a>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </ListGroup> */}
      </Card>
    </div>
  );
};

export default AppSettingPage;
{
  /*
    // <div className="container-fluid privacyPolicyImgbox">
    //   <div
    //     className="container privacyPolicyBellowTextBox"
    //     style={{ height: "100%" }}
    //   >
    //     <div id="scroll" style={{ height: "100%" }}>
    //       {/* <Accordion style={{ height: "100%" }}>
    //         <Accordion.Item
    //           eventKey="0"
    //           style={{
    //             backgroundColor: "transparent",
    //             borderColor: "transparent",
    //           }}
    //         >
    //           <Accordion.Header>EXPLORE</Accordion.Header>
              // <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
              //   <ul className="custom-bullet">
              //     <li className="nav-item">
              //       <a className="nav-link" href="/home">
              //         Home
              //       </a>
              //     </li>
              //     <li className="nav-item">
              //       <a className="nav-link" href="/browse">
              //         Browse
              //       </a>
              //     </li>
              //     <li className="nav-item">
              //       <a className="nav-link" href="/subscribe">
              //         Subscribe
              //       </a>
              //     </li>
              //   </ul>
              // </Accordion.Body>
    //         </Accordion.Item>
    //         <Accordion.Item
    //           eventKey="2"
    //           style={{
    //             backgroundColor: "transparent",
    //             borderColor: "transparent",
    //           }}
    //         >
    //           <Accordion.Header>QUICK LINKS</Accordion.Header>
    //           <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
                // <ul className="custom-bullet">
                //   <li className="nav-item">
                //     <a className="nav-link" href="/about-us">
                //       About Us
                //     </a>
                //   </li>
                //   <li className="nav-item">
                //     <a className="nav-link" href="/contact-us">
                //       Contact Us
                //     </a>
                //   </li>
                //   <li className="nav-item">
                //     <a className="nav-link" href="/support">
                //       Support
                //     </a>
                //   </li>
                //   <li className="nav-item">
                //     <a className="nav-link" href="/CookiePolicy">
                //       Cookie Policy
                //     </a>
                //   </li>
                // </ul>
    //           </Accordion.Body>
    //         </Accordion.Item>
    //         <Accordion.Item
    //           eventKey="1"
    //           style={{
    //             backgroundColor: "transparent",
    //             borderColor: "transparent",
    //           }}
    //         >
    //           <Accordion.Header>LEGAL</Accordion.Header>
    //           <Accordion.Body style={{ backgroundColor: "rgb(66,66,66)" }}>
    //             <ul className="custom-bullet">
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/privacy">
    //                   Privacy Policy
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/terms-and-conditions">
    //                   Terms &amp; Conditions
    //                 </a>
    //               </li>
    //               <li className="nav-item">
    //                 <a className="nav-link" href="/refund-policy">
    //                   Refund Policy
    //                 </a>
    //               </li>
    //             </ul>
    //           </Accordion.Body>
    //         </Accordion.Item>
    //       </Accordion> 
    //     </div>
    //   </div>
    // </div>
  */
}
